export enum BitwardenProductType {
  PasswordManager = 0,
  SecretsManager = 1,
}
